import React from 'react';
import TextField from '@material-ui/core/TextField';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<TextField
			error={props.error}
			helperText={props.error}
			id="outlined-textarea"
			label={props.label}
			multiline
			onChange={props.onChange}
			value={props.value}
			variant="outlined"
		/>
	);
});
